<template>
  <b-checkbox
    :model-value="value"
    :native-value="nativeValue"
    :disabled="disabled"
    @update:model-value="onInput"
  >
    <slot />
  </b-checkbox>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CheckboxView',
  emits: ['input'],
  props: {
    value: {
      required: false,
      default: false
    },
    nativeValue: {
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(...args) {
      this.$emit('input', ...args);
    }
  }
};
</script>
